export default __webpack_public_path__ + "static/media/hand.729124a0.svg";